exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".entityUser{color:red}.boldHr{border:2px solid #596568;margin:auto;margin-bottom:2%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/stylus-loader!./client/app/components/admin/entity/edit/entityUser/entityUser.styl
// module id = 748
// module chunks = 0